import fr from 'facet-rest';
import { DateInputSmall } from 'Packages/FacetDesign/Components/DateInput';
import { CurrencyInputSmall } from 'Packages/FacetDesign/Components/CurrencyInput';
import { SelectInputSmall } from 'Packages/FacetDesign/Components/SelectInput';
import { NumberInputSmall } from 'Packages/FacetDesign/Components/NumberInput';
import { TextInputSmall } from 'Packages/FacetDesign/Components/TextInput';
import { AutoCompleteInputSmall } from 'Packages/FacetDesign/Components/AutoCompleteInput';
import { CheckboxInputSmall } from 'Packages/FacetDesign/Components/CheckboxInput';
import { SwitchInput } from 'Packages/FacetDesign/Components/SwitchInput';
import { SSNInputSmall } from 'Packages/FacetDesign/Components/SSNInput';
import { PhoneInputLarge, PhoneInputSmall } from 'Packages/FacetDesign/Components/PhoneInput';
import { PercentInputSmall } from 'Packages/FacetDesign/Components/PercentInput';
import { buildFacetDesignOverride } from './FacetDesignOverride';

const overrideReadOnly = { ordinal: 200 };

// This should never be exported. By making this only available via the function below we remove the possibility of
// this override getting accidentally adjusted downstream via directly importing it and amending with .override which
// will mutate the entire base override globally.
const baseOverride = buildFacetDesignOverride()
  .typeOverride('string', { _component: () => TextInputSmall }, overrideReadOnly) // Needs to support rowsMax/rowsMin/multiple
  .typeOverride('date', { _component: () => DateInputSmall }, overrideReadOnly)
  .typeOverride('picklist', { _component: () => SelectInputSmall }, overrideReadOnly) // TODO: Support required
  .typeOverride('multipicklist', {
    _component: () => SelectInputSmall,
    _customProps: { multiple: true },
  }, overrideReadOnly)
  .typeOverride('number', { _component: () => NumberInputSmall }, overrideReadOnly)
  .typeOverride('bool', { _component: () => CheckboxInputSmall }, overrideReadOnly)
  .override({ hint: 'autocomplete' }, { _component: () => AutoCompleteInputSmall }, overrideReadOnly)
  // TODO: Need FacetDesign input for hint: email
  // TODO: Need FacetDesign input for hint: password
  .override({ hint: 'phoneNumber' }, { _component: () => PhoneInputSmall }, overrideReadOnly)
  .override({ type: 'phone' }, { _component: () => PhoneInputLarge }, overrideReadOnly)
  // TODO: Need FacetDesign input for hint: richtext
  .override({ hint: 'ssn' }, { _component: () => SSNInputSmall }, overrideReadOnly)
  .override({ hint: 'switch' }, { _component: () => SwitchInput }, overrideReadOnly)
  .override({ hint: 'taxid' }, { _component: () => SSNInputSmall }, overrideReadOnly) // What is the difference between taxid and ssn?
  .override({ hint: 'usd' }, { _component: () => CurrencyInputSmall }, overrideReadOnly)
  .override({ hint: 'percent' }, { _component: () => PercentInputSmall }, overrideReadOnly)
  .override({ readonly: true }, { _component: () => TextInputSmall }, overrideReadOnly)
  // TODO: Need FacetDesign input for hint: zipcode
  .done();

export const buildFacetDesignFilterFormOverride = () => fr.metaOverride({ base: baseOverride });
